

export default [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: () => import('@views/home'),
  //   meta: {
  //     title: '6 8nm,654vb hjvi4首页',
  //   },
  // },
  {
    path: '/login',
    name: 'login',
    component: () => import('@views/login'),
    meta: {
      title: '登录',
    },
  },
  // {
  //   path: '/dashboard/sportpark',
  //   name: 'dashboard',
  //   component: () => import('@views/dashboard'),
  //   meta: {
  //     title: '上海市民体育公园场馆',
  //   },
  // },
  {
    path: '/dashboard/putuo',
    name: 'putuo',
    component: () => import('@views/putuo'),
    meta: {
      title: '普陀安全管理',
    },
  },
]
